<template>
  <div class="container-xxl flex-col flex-stretch">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "GeneralContainer.vue"
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>